const currentEnv = process.env.REACT_APP_ENV;

export const c2bOmsUrl = () => {
    const urls = {
        QA: 'https://c2b-oms.qac24svc.dev/',
        STAGING: 'https://stage-c2b-oms.qac24svc.dev/',
        PRODUCTION: 'https://c2b-oms.c24.tech/'
    };
    return urls[currentEnv];
};

export const c2bListingAeUrl = () => {
    const urls = {
        QA: 'https://c2b-listing-ae.qac24svc.dev/',
        STAGING: 'https://stage-c2b-listing-ae.qac24svc.dev/',
        PRODUCTION: 'https://c2b-listing-ae.c24.tech/'
    };
    return urls[currentEnv];
};

export const c2bAuctionAeUrl = () => {
    const urls = {
        QA: 'https://c2b-auction-ae.qac24svc.dev/',
        STAGING: 'https://stage-c2b-auction-ae.qac24svc.dev/',
        PRODUCTION: 'https://c2b-auction-ae.c24.tech/'
    };
    return urls[currentEnv];
};

export const userAuthUrl = () => {
    const urls = {
        QA: 'https://user-auth-service.qac24svc.dev/',
        STAGING: 'https://stage-user-auth-service.qac24svc.dev/',
        PRODUCTION: 'https://user-auth-service.c24.tech/'
    };
    return urls[currentEnv];
};

export const c24UserServiceUrl = () => {
    const urls = {
        QA: 'https://c24-user-service.qac24svc.dev/',
        STAGING: 'https://c24-user-service-stage.qac24svc.dev/',
        PRODUCTION: 'https://api.cars24.com/gw/plt/usersvc/'
    };
    return urls[currentEnv];
};

export const userProfileMeUrl = () => {
    const urls = {
        QA: 'https://user-profile-me.qac24svc.dev/',
        STAGING: 'https://stage-user-profile-me.qac24svc.dev/',
        PRODUCTION: 'https://user-profile-me.c24.tech/'
    };
    return urls[currentEnv];
};

export const c2bNotificationUrl = () => {
    const urls = {
        QA: 'https://notification-engine-me.qac24svc.dev/',
        STAGING: 'https://stage-notification-engine-me.qac24svc.dev/',
        PRODUCTION: 'https://notification-engine-me.c24.tech/'
    };
    return urls[currentEnv];
};
